<template>
  <div class="pre-pare-detail">
    <div class="pre-pare-detail__head display-flex-center justify-content-between">
      <div class="pre-pare-detail__head__options">
        <a
          href="javascript:;"
          class="pre-pare-detail__head__options__icon display-flex-center justify-content-center"
          :class="{'bg-main-light': openOptionsDetail}"
          @click="toggleOpenOptionMenu"
        >
          <i class="icon-category primary-color font-size-20"></i>
        </a>
        <ul class="margin-0 border-rd-4" :class="{'active': openOptionsDetail}">
          <li><a href="javascript:;" @click="submit()">Lưu và thoát</a></li>
          <li><a href="javascript:;" @click="handleOpenModalInfo()">Thông tin</a></li>
          <li v-if="lessonId !== 0"><a href="javascript:;" @click="export2Pdf()">Tải xuống</a></li>
          <!-- <li><a href="javascript:;">Trợ giúp</a></li> -->
          <li><a href="javascript:;" @click="exit()">Thoát</a></li>
          <li><a v-if="lessonId !== 0" href="javascript:;" class="color-err" @click="delLesson()">Xóa bài giảng</a></li>
        </ul>
      </div>
      <h1 class="pre-pare-detail__title margin-0 p-0 book-viewer__title font-size-18 secondary-color-txt font-sanpro-semibold">
        {{ lessonInfo.title }}
      </h1>
      <a href="javascript:;" class="btn btn-main border-rd-20 font-size-16 display-flex-center justify-content-center" @click="handleSlideshow()">
        <i class="icon-next color-light"></i> <span class="only-pc">Trình chiếu</span>
      </a>
    </div>
    <div class="pre-pare-detail__body position-rel" :class="{'pre-pare-detail__body--scale': scaleSlide !== 1}">
      <div class="pre-pare-detail__list color_bg_gray_light" :class="{'active': openListItemSlide}">
        <div class="book-viewer__cats__wrap">
          <h2 class="pre-pare-detail__list__head primary-color-txt font-size-24 font-sanpro-semibold">
            Danh sách
          </h2>
        </div>
        <vue-custom-scrollbar
          class="scroll-area pre-pare-detail__items book-viewer__cats__wrap"
          :settings="{maxScrollbarLength: 300}"
        >
            <div v-for="(item, index) in slidesMain" :key="index" class="item position-rel" :class="{'active': slideIndexVisible === index}">
              <div class="item__wrap">
                <div class="item__head aspect-ratio aspect-ratio--16-9 bg-color-light" @click="showSlider(item, index)">
                  <div class="item__img">
                    <img v-if="item.imageBase64" :src="`${base64Define}${item.imageBase64}`" alt="">
                    <img v-else-if="item.imageUrl && isFullLink(item.imageUrl)" :src="item.imageUrl" alt="">
                    <img v-else-if="item.imageUrl && !isFullLink(item.imageUrl)" :src="`${baseUrl}/${item.imageUrl}`" alt="">
                  </div>
                  <!-- <div :id="item.lessonPlanItemId" v-html="item.imageBase64"></div> -->
                </div>
                <div class="item__body">
                  <h5 class="item__position margin-0 font-size-14 primary-bg-color color-light">{{ index + 1 }}</h5>
                  <a v-if="slidesMain.length > 1" href="javascript:;" class="item__del" @click="delSlider(index)">
                    <i class="icon-close font-size-10 secondary-color-txt"></i>
                  </a>
                </div>
              </div>  
            </div>
            <div class="item position-rel" @click="addSlider()">
              <div class="item__wrap">
                <div class="item__head aspect-ratio aspect-ratio--16-9 bg-color-light"></div>
              </div>
              <div class="item__body">
                <a href="javascript:;" class="item__add"><i class="icon-plus font-size-22"></i></a>
              </div>
            </div>
        </vue-custom-scrollbar>
      </div>
      <CanvasSlide
        v-if="slidesMain && slidesMain.length > 0"
        :class="{'active': openSidebarActions || openListItemSlide, 'active-right': openSidebarActions, 'active-left': openListItemSlide}"
        :openListItemSlide="openListItemSlide"
        :openSidebarActions="openSidebarActions"
      />
      <SidebarActions v-if="slidesMain && slidesMain.length > 0" @toggleActions="handleToggleSidebarActions" :closeActionSidebar="openListItemSlide" />
    </div>
    <div class="pre-pare-detail__footer display-flex-center justify-content-between color_bg_gray_light">
      <a
        href="javascript:;"
        class="primary-color font-size-16 font-sanpro-semibold book-viewer__footer__cats border-rd-20 position-rel display-flex-center justify-content-center"
        :class="{'btn-2': openListItemSlide}"
        @click="handleToggleSidebarListItem"
      >
        <i class="icon-list font-size-18"></i> 
        <span class="only-pc">Danh sách</span>
      </a>
      <div class="pre-pare-detail__footer__center">
        <div class="pre-pare-detail__paging display-flex-center">
          <button class="btn btn-main border-rd-20 display-flex-center justify-content-center" @click="prevSlide()">
            <i class="icon-prev color-light font-size-18"></i>
          </button>
          <span class="pre-pare-detail__paging__num display-flex-center justify-content-center bg-color-light border-rd-20 secondary-color-txt">
            {{slideIndexVisible + 1}}/{{slidesMain.length}}
          </span>
          <button class="btn btn-main border-rd-20 display-flex-center justify-content-center" @click="nextSlide()">
            <i class="icon-next color-light font-size-18"></i>
          </button>
        </div>
      </div>
      <div class="pre-pare-detail__footer__end">
        <div class="pre-pare-detail__zoom btn btn-white border-rd-20 display-flex-center justify-content-between">
          <button class="zoom-out border-0 p-0 bg-transparent" @click="zoomOut()">
            <i class="icon-minus font-size-18 secondary-color-txt"></i>
          </button>
          <span class="font-size-17 secondary-color-txt">{{ Math.ceil(scaleSlide*100) }} %</span>
          <button class="zoom-in border-0 p-0 bg-transparent" @click="zoomIn()">
            <i class="icon-plus font-size-18 secondary-color-txt"></i>
          </button>
        </div>
      </div>
    </div>
    <ModalViewVideoAudio v-if="linkVideoAudio" />
    <Slideshow v-if="isOpenSlideshow" />
    <ModalPreviewMedia v-if="indexPreviewMedia > -1" />
  
    <b-modal id="modal_info_lesson" class="modal-info" hide-footer size="lg" scrollable centered>
      <template v-slot:modal-header>
        <div class="modal-info__head modal-info__head--psmall display-flex-center justify-content-between full-width">
          <h4 class="modal-info__title font-sanpro-bold primary-color-txt">Thông tin</h4>
          <span @click="$bvModal.hide('modal_info_lesson')" class="modal-info__close"><i class="icon-close"></i></span>
        </div>
      </template>
      <div class="modal-info__body primary-color-txt font-sanpro-light bg-color-light">
        <div class="pre-pare__add__modal">
          <form class="needs-validation creat-dt" novalidate>
            <div class="form-group" :class="{ 'is-invalid': submitted && $v.lessonInfo.title.$error }">
              <input
                type="text"
                v-model="lessonInfo.title"
                class="form-bg-gray-light form-30h border-rd-20 full-width"
                id="tieude"
                placeholder="Tên bài giảng"
              />
              <p v-if="!lessonInfo.title" class="form-err-noti four-color font-size-15">Bạn hãy nhập tên bài bài giảng</p>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-item">
                  <select v-model="lessonInfo.classId" class="form-bg-gray-light form-30h border-rd-20 full-width disabled">
                    <option v-for="item of classes" :key="item.classId + '-class'" :value="item.classId">
                      {{ item.className }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-item">
                  <select v-model="lessonInfo.subjectId" class="form-bg-gray-light form-30h border-rd-20 full-width disabled">
                    <option v-for="item of subjects" :key="item.subjectId + '-subject'" :value="item.subjectId">
                      {{ item.subjectName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-action display-flex-center justify-content-end">
              <a href="javascript:;" class="font-size-16 primary-color font-weight-semi-bold" @click="$bvModal.hide('modal_info_lesson')">Hủy</a>
              <button
                type="button"
                class="btn btn-main font-size-16 border-rd-20 display-flex-center justify-content-center"
                :class="{'disabled': !lessonInfo.title}"
                @click="$bvModal.hide('modal_info_lesson')"
              >
                Hoàn thành
              </button>
            </div>
          </form>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  // import { fabric } from 'fabric';
  import lessonService from './../_api/lessonService'
  import fileService from './../_api/fileService'
  import classService from './../_api/classService'
  import { required } from "vuelidate/lib/validators"
  import { APP_CONFIG } from '@/utils/constants'
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import SidebarActions from './../_components/detail/SidebarActions.vue'
  import CanvasSlide from './../_components/detail/CanvasSlide.vue'
  import { STORE_KEY, BASE_64_DEFINE } from './../_store/constants'
  import mixinsDetailLesson from './../_store/mixinsDetailLesson'
  import ModalViewVideoAudio from './../_components/detail/ModalViewVideoAudio.vue'
  import Slideshow from './../_components/detail/Slideshow.vue'
  import ModalPreviewMedia from './../_components/detail/ModalPreviewMedia.vue'
  import mixinsFiles from '@/components/content-files/mixinsFiles'

	export default{
    name: 'PrepareDocEdit',
    mixins: [ mixinsFiles, mixinsDetailLesson ],
    components: {
      vueCustomScrollbar,
      SidebarActions,
      CanvasSlide,
      ModalViewVideoAudio,
      Slideshow,
      ModalPreviewMedia
    },
		data: function () {
      return {
        openOptionsDetail: false,
        openListItemSlide: false,
        openSidebarActions: false,
        lessonInfo: { title: '', classId: 0, subjectId: 0 },
        subjects: [],
        baseUrl: APP_CONFIG.appUrl,
        imgCdnUrl: APP_CONFIG.bookImgCdnUrl,
        base64Define: BASE_64_DEFINE,
        scale: 1,
        submitted: false,
      }
    },
    validations: {
      lessonInfo: {
        title: { required }
      },
    },
    computed: {
      ...mapState(STORE_KEY, ['classes' ,'slidesMain', 'slideIndexVisible', 'slideCurr', 'linkVideoAudio', 'isOpenSlideshow', 'indexPreviewMedia', 'scaleSlide', 'scaleMax', 'scaleMin']),
      lessonId () {
        return parseInt(this.$route.params.id)
      }
    },
    watch: {
    },
    created() {
      this.initPage()
    },
    mounted () {
      window.addEventListener('keyup', this.onKeyup)
        // this.canvasObj.on("object:added", function(t) {
        //     //console.log("object:added");
        // });
        
        // this.canvasObj.on("object:modified", function(t) {
        //     //console.log("object:modified");
        //     that.savingSlider();
        // });

        // this.canvasObj.on("object:moving", function(t) {
        //     var e = t.target;
        //     e.currentHeight > e.canvas.height || e.currentWidth > e.canvas.width || (e.setCoords(), (e.getBoundingRect().top < 0 || e.getBoundingRect().left < 0) && (e.top = Math.max(e.top, e.top - e.getBoundingRect().top), e.left = Math.max(e.left, e.left - e.getBoundingRect().left)), (e.getBoundingRect().top + e.getBoundingRect().height > e.canvas.height || e.getBoundingRect().left + e.getBoundingRect().width > e.canvas.width) && (e.top = Math.min(e.top, e.canvas.height - e.getBoundingRect().height + e.top - e.getBoundingRect().top), e.left = Math.min(e.left, e.canvas.width - e.getBoundingRect().width + e.left - e.getBoundingRect().left)))
        // });

        // this.canvasObj.on("selection:created", function(t) {
        //    //console.log("selection:created");
        // });

        // this.canvasObj.on("selection:updated", function(t) {
        //     //console.log("selection:updated");
        // });

        // this.canvasObj.on("before:selection:cleared", function(t) {
        //     //console.log("before:selection:cleared");
        //     that.savingSlider();
        // });

        // this.canvasObj.on("mouse:dblclick", function(t) {
        //     //console.log("mouse:dblclick");
        //     that.handleMouseDbClick(t.target);
        // });

        // $(document).ready(function(){
            // $(".button-bl").click(function(){
            //     $(".book-viewer__cats").toggleClass("active");
            //     $(".book-viewer__body").toggleClass("body-active");
            //     $(".bg-list").toggleClass("col-md-4");

            //     $(".tab-content>.active").removeClass( "active" );
            //     $("#v-pills-tab .nav-link").removeClass( "active" );
            // });
            // $(".close-tab").click(function(){
            //     $(".tab-content>.active").removeClass( "active" );
            //     $("#v-pills-tab .nav-link").removeClass( "active" );
            //     // $('#main-canvas').attr('style','padding-left: 150px');
            // });
            // $('.icon-menu-ds').click(function(){
            //     $(".list-mn").slideToggle();
            // });
            // $(document).click(function (e)
            // {
            //     // Đối tượng container chứa popup
            //     var container1 = $(".menu-ds");
            //     // Nếu click bên ngoài đối tượng container thì ẩn nó đi
            //     if (!container1.is(e.target) && container1.has(e.target).length === 0)
            //     {
            //         $(".list-mn").hide(500);
            //     }
            // });
            
            // $('#popup-video').on('hidden.bs.modal', function (e) {
            //     var video = document.getElementById('video');
            //     video.src = '';
            // });

            // $('#popup-audio').on('hidden.bs.modal', function (e) {
            //     var audio = document.getElementById('audio');
            //     audio.src = '';
            // });

            // $('#popup-show-slider').on('hidden.bs.modal', function (e) {
            //     fabric.Object.prototype.hasControls = true;
            //     fabric.Object.prototype.hasBorders = true;
            // });
             
            // $('#popup-show-video').on('hidden.bs.modal', function (e) {
            //     var video = document.getElementById('video-show');
            //     video.src = '';
            // });

            // $('#popup-show-audio').on('hidden.bs.modal', function (e) {
            //     var audio = document.getElementById('audio-show');
            //     audio.src = '';
            // });

        //     window.addEventListener('keydown', function(e) {
        //         that.handleNextPreviousSlider(e.keyCode);
        //         that.handleKeydown(e.keyCode);
        //     });
        // });

        // this.canvasSlider = new fabric.Canvas("canvas"),

        // this.canvasSlider.on("object:moving", function(e) {
        //     //console.log("object:moving");
        //     e.target.lockMovementX = true;
        //     e.target.lockMovementY = true;
        //     e.target.lockScalingX = true;
        //     e.target.lockScalingY = true;
        //     e.target.lockUniScaling = true;
        //     e.target.lockRotation = true;
        // });
        // this.canvasSlider.on("mouse:dblclick", function(t) {
        //     //console.log("mouse:dblclick");
        //     that.handleMouseDbShowClick(t.target);
        // });

        // window.addEventListener('resize', this.handleResize);

        // this.initCanvasSize();
    },
    destroyed () {
      document.body.removeEventListener('resize', this.handleResize)
      this.acSetSlideVisibleIndex(-1)
      window.removeEventListener('keyup', this.onKeyup)
    },

    methods: {
        ...mapActions('common', ['setLoading']),
        ...mapActions(STORE_KEY, ['acSetSlidesMain', 'acSetSlidesImgMain', 'acSetClasses', 'acSetSlideVisibleIndex', 'acSetVisibleSlideshow', 'acSetScaleSlide']),

        initPage () {
          this.getClasses()
          if (this.lessonId === 0) {
            let querySample = this.$route.query.sample
            this.acSetSlideVisibleIndex(0)
            this.lessonInfo = {
              ...this.lessonInfo,
              title: this.$route.params.title,
              classId: parseInt(this.$route.params.classId),
              subjectId: parseInt(this.$route.params.subjectId)
            }
            if (querySample) {
              this.setSlideForSample(parseInt(querySample))
            } else {
              this.acSetSlidesMain([{orderNo: 0, items: [], isNew: true, lessonPlanItemId: 0}])
            }
          } else {
            this.getLessonById()
          }
        },

        setSlideForSample (id) {
          let self = this
          lessonService.getLessonsSampleDetail(id).then(async res => {
            if (!res) {
              self.$router.push({name: 'prepareLessonAdd'})
              return;
            }
            if (res && res.title) {
              this.lessonInfo = {
                ...this.lessonInfo,
                title: res.title
              }
            }
            let slideItem = {orderNo: 0, items: [], isNew: true, lessonPlanItemId: 0, imageUrl: ''}
            if (res && res.lessonPlan && res.lessonPlan.totalPage && res.lessonPlan.totalPage > 0) {
              let dataSlides = []
              for (let i = 0; i < res.lessonPlan.totalPage; i++) {
                let imageUrl = `${self.imgCdnUrl}${res.lessonPlan.fileName}-${i + 1}.jpg`

                dataSlides.push({
                  orderNo: i,
                  items: [],
                  isNew: true,
                  lessonPlanItemId: 0,
                  backgroundImage: imageUrl,
                  imageUrl
                })
                // self.acSetSlidesMain(
                //   [
                //     ...self.slidesMain,
                //     {
                //       ...slideItem,
                //       orderNo: i,
                //       backgroundImage: imageUrl,
                //       imageUrl
                //     }
                //   ]
                // )

                // if (i === res.lessonPlan.totalPage - 1) {
                //   console.log('cgcgcg: ', self.slideCurr)
                //   self.setDataSaved()
                // }
              }

              await self.acSetSlidesMain(dataSlides)
              self.setDataSaved()
            }
          })
        },

        getClasses () {
          let self = this
          self.setLoading(true)
          classService.get().then(res => {
            if (res && res.length > 0) {
              this.acSetClasses(res)
              let indexClassActive = res.findIndex(cl => cl.classId === parseInt(this.$route.params.classId))
              this.subjects = indexClassActive > -1 ? res[indexClassActive].subjects : []
            }
          })
          .finally(() => self.setLoading(false))
        },

        handleToggleSidebarListItem () {
          this.openListItemSlide = !this.openListItemSlide
          this.openSidebarActions = false
        },

        toggleOpenOptionMenu () {
          this.openOptionsDetail = !this.openOptionsDetail
        },

        handleToggleSidebarActions (val) {
          this.openSidebarActions = val
          this.openListItemSlide = false
        },

        handleOpenModalInfo () {
          this.$bvModal.show('modal_info_lesson')
          this.openOptionsDetail = false
        },

        addSlider () {
          let slideItem = {orderNo: this.slidesMain.length, items: [], isNew: true, lessonPlanItemId: 0}
          this.acSetSlidesMain([...this.slidesMain, slideItem])
        },

        delSlider(index){
          this.slidesMain.splice(index, 1)
        },

        showSlider(item, index){
          this.slideCurr.clear()
          this.acSetSlideVisibleIndex(index)
        },

        prevSlide () {
          this.slideIndexVisible > 0 && this.slideCurr.clear() && this.acSetSlideVisibleIndex(this.slideIndexVisible - 1)
        },

        nextSlide () {
          this.slideIndexVisible < this.slidesMain.length - 1 && this.slideCurr.clear() && this.acSetSlideVisibleIndex(this.slideIndexVisible + 1)
        },

        onKeyup(e) {
          e.keyCode === 37 && this.prevSlide()
          e.keyCode === 39 && this.nextSlide()
        },

        getLessonById(){
          let self = this;
          self.setLoading(true);

          lessonService.getById(this.lessonId)
          .then(res => {
            if (res) {
              self.lessonInfo = res;
              if (res.listModels && res.listModels.length > 0) {
                // console.log('AAAAAAAAAAA')
                res.listModels.map(slide => {
                  // console.log('DETAIL: ', slide)
                  if (slide.jsonValue) {
                    let jsonData = JSON.parse(slide.jsonValue)
                    slide['items'] = jsonData.objects
                    // let itemsSaved = JSON.parse(slide.jsonValue)
                    // let items = itemsSaved.objects
                    // items.length > 0 && items.map((obj, index) => {
                    //   const { type_detail, layout } = itemsSaved.other_keys[index]
                    //   items[index]['type_detail'] = type_detail
                    //   items[index]['layout'] = layout
                    // })
                    // slide['items'] = items
                    // slide['items'] = JSON.parse(slide.jsonValue)
                  }
                })
              }
              self.acSetSlidesMain(res.listModels)
              return res
            }
          })
          .then(() => {
            self.nextSlide()
          })
          .finally(() => self.setLoading(false));
        },

        submit () {
          let self = this
          this.openOptionsDetail = false
          this.submitted = true;
          this.$v.$touch();
          if (this.$v.$invalid) {
            return;
          }
          
          if(this.slidesMain.length === 0){
            this.$toast.error('Vui lòng thêm slider')
            return;
          } else {
            // this.slidesMain.map(slide => {
            //   if (slide.items) {
            //     // let itemKeys = []
            //     // Convert to other obj because item is fabric obj haven't key type_detail & layout
            //     // slide.items.map(item => {
            //     //   itemKeys.push({layout: item.layout, type_detail: item.type_detail})
            //     // })
            //     // slide['jsonValue'] = JSON.stringify({objects: slide.items, other_keys: itemKeys})
            //     // slide['jsonValue'] = JSON.stringify(slide.items)
            //   }
            // })
            let dataReq = {
              ...this.lessonInfo,
              listModels: this.slidesMain
            }
            // console.log('dataReq submit: ', dataReq);
            // return;
            
            self.setLoading(true);
            if(self.lessonId > 0){
              lessonService.update(dataReq)
              .then((response) => {
                if (response.data.status == 'success') {
                  self.$toast.success("Cập nhật thành công");
                  self.exit()
                } else {
                  self.$toast.error("Cập nhật không thành công");
                }
              })
              .finally(() => self.setLoading(false))
            } else {
              lessonService.create(dataReq)
              .then((response) => {
                if (response.data.status == 'success') {
                  self.$toast.success('Thêm mới thành công')
                  self.exit()
                } else {
                  self.$toast.error('Thêm mới không thành công')
                }
              })
              .finally(() => self.setLoading(false))
            }
          }
        },

        exit () {
          this.$router.push('/danh-sach-giao-an');
        },

        delLesson() {
          if(this.lessonId > 0){
            let self = this;
            self.setLoading(true);
            var data = { Id: self.lessonId }
            lessonService.delete(data)
            .then((response) => {
              if (response.data.status == 'success') {
                self.$toast.success('Xóa thành công')
                self.$router.push('/danh-sach-giao-an')
              }
            })
            .finally(() => self.setLoading(false));
          } else{
            this.$router.push('/danh-sach-giao-an');
          }
        },


        handleSlideshow () {
          this.acSetVisibleSlideshow(true)
        },

        zoomOut () {
          this.scaleSlide > this.scaleMin && this.acSetScaleSlide(this.scaleSlide - 0.1)
        },

        zoomIn () {
          this.scaleSlide < this.scaleMax && this.acSetScaleSlide(this.scaleSlide + 0.1)
        },












        
        // closeModalSlider(){
        //     this.isShow = false;
        //     // $('#popup-show-slider').modal('hide');
        // },

        // closeDs(){
        //     // $(".book-viewer__cats").removeClass("active");
        //     // $(".book-viewer__body").removeClass("body-active");
        //     // $(".bg-list").removeClass("col-md-4");
        //     // $('#main-canvas').attr('style','padding-left: 75px');

        //     this.closeDsResize();
        //     this.openDs = false;
        // },

        // showModalSlider(){
        //     this.isShow = true;
        //     // $('#popup-show-slider').modal();
        //     // $('.modal-backdrop').attr('style', 'opacity : 1');
        //     fabric.Object.prototype.hasControls = false;
        //     fabric.Object.prototype.hasBorders = false;
        //     var sliders = this.lesson.Items;
        //     this.totalSlider = this.lesson.Items.length;
        //     this.canvasSlider.loadFromJSON(sliders[0].Json);
        //     this.sliderShow = 1;
        // },

        // handleKeydown(keyCode) {
        //     if (keyCode == 46) {
        //         this.deleteObject();
        //     }
        // },

        // handleNextPreviousSlider(keyCode){
        //     if(this.isShow){
        //         var sliders = this.lesson.Items;
        //         if(this.totalSlider == 0 || sliders == null){
        //             return;
        //         }
        //         if(keyCode == 37 || keyCode == 40){
        //             if(this.sliderShow > 1){
        //                 this.sliderShow = this.sliderShow - 1;
        //                 this.canvasSlider.loadFromJSON(sliders[this.sliderShow -1].Json);
        //             }
        //             else if(this.sliderShow == 1){
        //                 this.sliderShow = sliders.length;
        //                 this.canvasSlider.loadFromJSON(sliders[this.sliderShow - 1].Json);
        //             }
        //         }
        //         else if(keyCode == 38 || keyCode == 39){
        //             this.sliderShow = this.sliderShow + 1;
        //             if(this.sliderShow <= this.totalSlider){
        //                 this.canvasSlider.loadFromJSON(sliders[this.sliderShow - 1].Json);
        //             }
        //             else if(this.sliderShow > this.totalSlider){
        //                 this.sliderShow = 1;
        //                 this.canvasSlider.loadFromJSON(sliders[this.sliderShow - 1].Json);
        //             }
        //         }
        //     }
        //     else{
        //         if(this.lesson.Items.length == 0 || this.lesson.Items == null){
        //             return;
        //         }
        //         if(keyCode == 37 || keyCode == 40){
        //             this.previousSlider(this.currentSlider.OrderSort - 1);
        //         }
        //         else if(keyCode == 38 || keyCode == 39){
        //             this.nextSlider(this.currentSlider.OrderSort + 1);
        //         }
        //     }
        // },

        // handleMouseDbShowClick(obj){
        //     if(obj.video_src != null && obj.video_src != ''){
        //         var videoObj = { name: obj.file_name, fullPath: obj.video_src };
        //         this.playShowVideo(videoObj);
        //     }
        //     else if(obj.audio_src != null && obj.audio_src != ''){
        //         var audioObj = { name: obj.file_name, fullPath: obj.audio_src };
        //         this.playShowAudio(audioObj);
        //     }
        // },

        // playShowAudio(audioObj) {
        //     this.currentObject = audioObj;
        //     var video = document.getElementById('audio-show');
        //     video.src = audioObj.fullPath;
        //     video.type = 'audio/mp3';
        //     video.play();
        //     // $('#popup-show-audio').modal();
        // },

        // playShowVideo(videoObj) {
        //     this.currentObject = videoObj;
        //     var video = document.getElementById('video-show');
        //     video.src = videoObj.fullPath;
        //     video.play();
        //     // $('#popup-show-video').modal();
        // },

        // isNumeric: function (n) {
        //     return n % 1 === 0;
        // },

        export2Pdf(){
            let self = this;
            self.setLoading(true);
            self.openOptionsDetail = false
            lessonService.export(this.lessonId)
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', this.lessonInfo.title + '.pdf');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    // alert('Export thành công');
                }).catch(e => { console.log(e) })
            .finally(() => { self.setLoading(false)});
        },

        // savingSlider(){
        //     this.lesson.Items.forEach((item, index) => {
        //         if(item.Id == this.currentSlider.Id){
        //             this.canvasSVG = this.canvasObj.toSVG();
        //             if(this.canvasSVG != null){
        //                 item.Json = JSON.stringify(this.canvasObj.toJSON());
        //                 item.Svg = this.canvasSVG;
        //                 this.currentSlider.Json = JSON.stringify(this.canvasObj.toJSON());
        //                 this.currentSlider.Svg = this.canvasSVG;
        //                 document.getElementById(item.Id).innerHTML = this.canvasSVG;
        //             }
        //         }
        //     });
        // },
        // nextSlider(index){
        //     if(index != this.lesson.Items.length + 1){
        //         this.currentSlider = this.lesson.Items[index - 1];
        //         this.showSlider(this.currentSlider);
        //     }

        //     if(index > this.lesson.Items.length){
        //         this.currentSlider = this.lesson.Items[0];
        //         this.showSlider(this.currentSlider);
        //     }
        // },
        // previousSlider(index){
        //     if(index > 0){
        //         this.currentSlider = this.lesson.Items[index - 1];
        //         this.showSlider(this.currentSlider);
        //     }
        //     if(index == 0){
        //         this.currentSlider = this.lesson.Items[this.lesson.Items.length - 1];
        //         this.showSlider(this.currentSlider);
        //     }
        // },

        // uploadImage() {
        //     let self = this;
        //     self.setLoading(true);
        //     this.file = this.$refs.file_image.files[0];
        //     var isValid = false;
        //     if (this.file.type !== '' && this.file.type.split('/').length == 2) {
        //         if (this.file.type.split('/')[0] == 'image') {
        //             isValid = true;
        //         }
        //     }
        //     if (!isValid) {
        //         alert("Vui lòng chọn file đúng định dạng");
        //         // $('#file_image').val(null);
        //     }
        //     else {
        //         var fileData = { name: this.file.name, fileExt: this.file.type.split('/')[1], fileSize: this.file.size, fileType: 1 };
        //         let formData = new FormData();
        //         formData.append('file', this.file);
        //         fileService.upload(formData).then((response) => {
        //             if (response.data.status == 'success') {
        //                 fileData.fileRef = response.data.data;
        //                 this.saveFile(fileData);
        //                 // $('#file_image').val(null);
        //             }
        //             else {
        //                 alert("Có lỗi khi upload file");
        //             }
        //         }).catch(e => {
        //             console.log(e);
        //         }).finally();
        //     }
        // },

        // uploadAudio() {
        //     let self = this;
        //     self.setLoading(true);
        //     this.file = this.$refs.file_audio.files[0];
        //     var isValid = false;
        //     if (this.file.type !== '' && this.file.type.split('/').length == 2) {
        //         if (this.file.type.split('/')[0] == 'audio') {
        //             isValid = true;
        //         }
        //     }
        //     if (!isValid) {
        //         alert("Vui lòng chọn file đúng định dạng");
        //         // $('#file_audio').val(null);
        //     }
        //     else {
        //         var fileData = { name: this.file.name, fileExt: this.file.type.split('/')[1], fileSize: this.file.size, fileType: 3 };
        //         let formData = new FormData();
        //         formData.append('file', this.file);
        //         fileService.upload(formData).then((response) => {
        //             if (response.data.status == 'success') {
        //                 fileData.fileRef = response.data.data;
        //                 this.saveFile(fileData);
        //                 // $('#file_audio').val(null);
        //             }
        //             else {
        //                 alert("Có lỗi khi upload file");
        //             }
        //         }).catch(e => {
        //             console.log(e);
        //         }).finally();
        //     }
        // },

        // uploadVideo() {
        //     let self = this;
        //     self.setLoading(true);
        //     this.fileVideo = this.$refs.file_video.files[0];
        //     var isValid = false;
        //     if (this.fileVideo.type !== '' && this.fileVideo.type.split('/').length == 2) {
        //         if (this.fileVideo.type.split('/')[0] == 'video') {
        //             isValid = true;
        //         }
        //     }
        //     if (!isValid) {
        //         alert("Vui lòng chọn file đúng định dạng");
        //         // $('#file_video').val(null);
        //     }
        //     else {
        //         var maxFileSizeMB = 10;  
        //         var bufferChunkSize = maxFileSizeMB * (1024 * 1024);    
        //         var fileStreamPos = 0;  
        //         var endPos = bufferChunkSize;  
        //         var size = this.fileVideo.size;  
        //         while (fileStreamPos < size)  
        //         {  
        //             this.fileChunk.push(this.fileVideo.slice(fileStreamPos, endPos));  
        //             fileStreamPos = endPos; 
        //             endPos = fileStreamPos + bufferChunkSize; 
        //         }
        //         this.totalFileChunk = this.fileChunk.length;  
        //     }
        // },

        // uploadChunk(chunk, fileName) {
        //     var formData = new FormData();  
        //     formData.append('file', chunk, fileName);  
        //     fileService.upload(formData).then((response) => {
        //         if (response.data.status == 'success') {
        //             this.fileChunk.shift();
        //             if (this.fileChunk.length == 0 && response.data.data !== null) {
        //                 var fileData = { name: this.fileVideo.name, fileExt: this.fileVideo.type.split('/')[1], fileSize: this.fileVideo.size, fileType: 2 };
        //                 fileData.fileRef = response.data.data;
        //                 this.saveFile(fileData);
        //                 // $('#file_video').val(null);
        //             }
        //         }
        //         else {
        //             alert("Có lỗi khi upload file");
        //         }
        //     }).catch(e => {
        //         console.log(e);
        //     }).finally();
        // },

        // saveFile(data) {
        //     let self = this;
        //     fileService.save(data).then((response) => {
        //         if (response.data.status == 'success') {
        //             if (data.fileType == 1) {
        //                 this.getImages();
        //                 this.addImageUrl(this.baseUrl + "/" + response.data.data.fileRef);
        //             }
        //             else if (data.fileType == 2) {
        //                 this.addVideo(response.data.data);
        //                 this.getVideos();
        //             }
        //             else if (data.fileType == 3) {
        //                 this.addAudio(response.data.data);
        //                 this.getAudios();
        //             }
        //         }
        //         else {
        //             alert("Có lỗi khi upload file");
        //         }
        //     }).catch(e => {
        //         console.log(e);
        //     }).finally(() => { self.setLoading(false)});
        // },

        // handleFileUpload(){
        //     this.file = this.$refs.file.files[0];
        // },

        // submitFile(){
        //     let formData = new FormData();
        //     formData.append('file', this.file);
        //     fileService.upload(formData).then((response) => {
        //         this.addImageUrl(response.data.Data.FullPath);
        //     }).catch(e => {
        //         this.errors.push(e)
        //     })
        //     .finally();
        // },

        // setCanvasBackground(imageUrl){
        //     const canvas = this.canvasObj;
        //     fabric.Image.fromURL(imageUrl, function(img) {
        //         //img.set({ 'left': 0 });
        //         //img.set({ 'top': 0 });
               
        //         img.scaleX = canvas.width / img.width;
        //         img.scaleY = canvas.height / img.height;
        //         //img.scaleToWidth(canvas.width);
        //         //img.scaleToHeight(canvas.height);

        //         canvas.setBackgroundImage(img);
        //         canvas.requestRenderAll();
        //     });
        // },
        // initSlider(){
        //     let id = this.makeId();
        //     var item = {
        //         Id: id,
        //         LessonId: 0,
        //         Svg: '',
        //         Json: '',
        //         OrderSort: 1
        //     };
        //     this.lesson.Title = "";
        //     this.lesson.ClassId = this.classId;
        //     this.lesson.SubjectId = this.subjectId;
        //     this.lesson.Items = [];
        //     this.lesson.Items.push(item);
        //     this.currentSlider = item;
        // },
        
        // getImages(){
        //     let self = this;
        //     self.setLoading(true);

        //     fileService.filter(1, this.imageName)
        //         .then((response) => {
        //             this.images = response.data.data;
        //         }).catch(e => {
        //             this.errors.push(e)
        //         })
        //         .finally(() => { self.setLoading(false)});
        // },
        // getVideos(){
        //     let self = this;
        //     self.setLoading(true);

        //     fileService.filter(2, this.videoName)
        //         .then((response) => {
        //             this.videos = response.data.data;
        //         }).catch(e => {
        //             this.errors.push(e)
        //         })
        //         .finally(() => { self.setLoading(false)});
        // },
        // getAudios(){
        //     let self = this;
        //     self.setLoading(true);

        //     fileService.filter(3, this.audioName)
        //     .then((response) => {
        //         this.audios = response.data.data;
        //     }).catch(e => {
        //         this.errors.push(e)
        //     })
        //     .finally(() => { self.setLoading(false)});
        // },
        // makeId(){
        //     var result           = '';
        //     var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        //     var charactersLength = characters.length;
        //     for ( var i = 0; i < 10; i++ ) {
        //         result += characters.charAt(Math.floor(Math.random() * charactersLength));
        //     }
        //     return result;
        // },
        
        // setActiveProp(name, value) {
        //     var object = this.canvasObj.getActiveObject();
        //     if (!object) return;
        //     object.set(name, value).setCoords();
        //     this.canvasObj.renderAll();
        // },

        // getActiveProp(name) {
        //     var object = canvas.getActiveObject();
        //     if (!object) return '';
          
        //     return object[name] || '';
        // },

        // setActiveStyle(styleName, value, object) {
        //     object = object || this.canvasObj.getActiveObject();
        //     if (!object) return;

        //     if (object.setSelectionStyles && object.isEditing) {
        //         var style = { };
        //         style[styleName] = value;
        //         object.setSelectionStyles(style);
        //         object.setCoords();
        //     }
        //     else {
        //         object.set(styleName, value);
        //     }

        //     object.setCoords();
        //     this.canvasObj.requestRenderAll();
        // },

        // getStroke(){
        //     return this.getActiveStyle('stroke');
        // },

        // setStroke(value){
        //     this.setActiveStyle('stroke', value);
        // },

        // getStrokeWidth(){
        //     return this.getActiveStyle('strokeWidth');
        // },

        // setStrokeWidth(value){
        //     this.setActiveStyle('strokeWidth', parseInt(value, 10));
        //     this.canvasObj.trigger('object:modified');
        // },

        // getOpacity(){
        //     return this.getActiveStyle('opacity') * 100;
        // },

        // setOpacity(value){
        //     this.setActiveStyle('opacity', parseInt(value, 10) / 100);
        //     this.canvasObj.trigger('object:modified');
        // },

        // setFontFamily(){
        //     this.setActiveProp('fontFamily', this.fontFamily.toLowerCase());
        //     this.canvasObj.trigger('object:modified');
        // },

        // setBold(){
        //     this.setActiveStyle('fontWeight', value ? 'bold' : '');
        //     this.canvasObj.trigger('object:modified');
        // },

        // setFontSize(value){
        //     this.setActiveStyle('fontSize', parseInt(value, 10));
        //     this.canvasObj.trigger('object:modified');
        // },

        // toggleItalic() {
        //     this.setActiveStyle('fontStyle',
        //     this.getActiveStyle('fontStyle') === 'italic' ? '' : 'italic');
        //     this.canvasObj.trigger('object:modified');
        // },

        // isUnderline() {
        //     return this.getActiveStyle('textDecoration').indexOf('underline') > -1 || this.getActiveStyle('underline');
        // },

        // isLinethrough() {
        //     return this.getActiveStyle('textDecoration').indexOf('line-through') > -1 || this.getActiveStyle('linethrough');
        // },

        // toggleLinethrough() {
        //     var value = this.isLinethrough()
        //     ? this.getActiveStyle('textDecoration').replace('line-through', '')
        //     : (this.getActiveStyle('textDecoration') + ' line-through');

        //     this.setActiveStyle('textDecoration', value);
        //     this.setActiveStyle('linethrough', !this.getActiveStyle('linethrough'));
        //     this.canvasObj.trigger('object:modified');
        // },
        // toggleUnderline() {
        //     var value = this.isUnderline()
        //     ? this.getActiveStyle('textDecoration').replace('underline', '')
        //     : (this.getActiveStyle('textDecoration') + ' underline');

        //     this.setActiveStyle('textDecoration', value);
        //     this.setActiveStyle('underline', !this.getActiveStyle('underline'));
        //     this.canvasObj.trigger('object:modified');
        // },

        // toggleBold() {
        //     this.setActiveStyle('fontWeight',
        //     this.getActiveStyle('fontWeight') === 'bold' ? '' : 'bold');
        //     this.canvasObj.trigger('object:modified');
        // },

        // setBgColor(value) {
        //     this.setActiveProp('backgroundColor', value);
        // },

        // getActiveStyle(styleName, object) {
        //     object = object || this.canvasObj.getActiveObject();
        //     if (!object) return '';

        //     return (object.getSelectionStyles && object.isEditing)
        //         ? (object.getSelectionStyles()[styleName] || '')
        //         : (object[styleName] || '');
        // },

        // setColor(value){
        //     var t = this.canvasObj.getActiveObject();
        //     null != t && (t.set("fill", value), t.set("opacity", 1), this.canvasObj.renderAll());
        //     this.canvasObj.trigger('object:modified');
        // },

        // setAlign(align) {
        //     let activeObj = this.canvasObj.getActiveObject();
           
        //     if(activeObj != null){
        //         switch (align) {
        //             case 'left':
        //                 activeObj.set({
        //                     left: 0
        //                 });
        //                 break;
        //             case 'right':
        //                 activeObj.set({
        //                     left: this.canvasObj.width - (activeObj.width * activeObj.scaleX)
        //                 });
        //                 break;
        //             case 'top':
        //                 activeObj.set({
        //                     top: 0
        //                 });
        //                 break;
        //             case 'bottom':
        //                 activeObj.set({
        //                     top: this.canvasObj.height - (activeObj.height * activeObj.scaleY)
        //                 });
        //                 break;
        //             case 'center':
        //                 activeObj.set({
        //                     left: (this.canvasObj.width / 2) - ((activeObj.width * activeObj.scaleX) / 2)
        //                 });
        //                 break;
        //         }
        //         activeObj.setCoords();
        //         this.canvasObj.renderAll();
        //         this.canvasObj.trigger('object:modified');
        //     }
        // },

        // addRect: function(type) {
        //     if(type == 1){
        //         var r = new fabric.Rect({
        //             left: 100,
        //             top: 100,
        //             width: 100,
        //             height: 100,
        //             fill: this.colorFill,
        //             originX: "left",
        //             originY: "top",
        //             centeredRotation: !0,
        //             stroke: this.colorFill,
        //             strokeWidth: 1
        //         });
        //         this.canvasObj.add(r);
        //         this.canvasObj.trigger('object:modified');
        //     }
        //     else if(type == 2){
        //         var r = new fabric.Rect({
        //             left: 200,
        //             top: 200,
        //             width: 100,
        //             height: 100,
        //             fill: "#ffffff",
        //             originX: "left",
        //             originY: "top",
        //             centeredRotation: !0,
        //             stroke: this.colorFill,
        //             strokeWidth: 1
        //         });
        //         this.canvasObj.add(r);
        //         this.canvasObj.trigger('object:modified');
        //     }
        //     else if(type == 3){
        //         var r = new fabric.Rect({
        //             left: 100,
        //             top: 100,
        //             width: 100,
        //             height: 100,
        //             fill: "#ffffff",
        //             originX: "left",
        //             originY: "top",
        //             centeredRotation: !0,
        //             stroke: this.colorFill,
        //             strokeWidth: 1
        //         });
        //         this.canvasObj.add(r);
        //         this.canvasObj.trigger('object:modified');
        //     }
        //     else if(type == 4){
        //         var r = new fabric.Rect({
        //             left: 100,
        //             top: 100,
        //             width: 100,
        //             height: 100,
        //             fill: "#ffffff",
        //             originX: "left",
        //             originY: "top",
        //             centeredRotation: !0,
        //             stroke: this.colorFill,
        //             strokeWidth: 1
        //         });
        //         this.canvasObj.add(r);
        //         this.canvasObj.trigger('object:modified');
        //     }
            
        // },
        // addText: function() {
        //     var t = new fabric.IText("Double click to edit.", {
        //         left: 100,
        //         top: 100,
        //         originX: "left",
        //         originY: "top",
        //         fontFamily: this.fontFamily
        //     });
        //     t.setShadow("0 0 0 #ffff"), t.set("strokeWidth", 0), t.set("fill", "#000"), this.canvasObj.add(t), t.setControlsVisibility({
        //         mt: !1,
        //         mb: !1
        //     });
        //     this.canvasObj.trigger('object:modified');
        // },
        
        // addCircle: function(type) {
        //     if(type == 1){
        //         var c = new fabric.Circle({
        //             left: 180, 
        //             top: 150, 
        //             radius: 60, 
        //             fill: this.colorFill, 
        //             stroke: this.colorFill, 
        //             strokeWidth: 1,
        //         });
        //         this.canvasObj.add(c);
        //         this.canvasObj.trigger('object:modified');
        //     }
        //     else if(type == 2){
        //         var c = new fabric.Circle({
        //             left: 280, 
        //             top: 250, 
        //             radius: 60, 
        //             fill: '#FFFFFF', 
        //             stroke: this.colorFill, 
        //             strokeWidth: 1,
        //         });
        //         this.canvasObj.add(c);
        //         this.canvasObj.trigger('object:modified');
        //     }  
        // },
        // addLine: function() {
        //     var line = new fabric.Line([0, 20, 150, 20],{ 
        //         left: 200,
        //         top: 200,
        //         fill: this.colorFill, 
        //         stroke: this.colorFill, 
        //         strokeWidth: 2
        //     });
        //     this.canvasObj.add(line);
        //     this.canvasObj.renderAll();
        //     this.canvasObj.trigger('object:modified');
        // },
        // addTriangle: function() {
        //     this.canvasObj.add(new fabric.Triangle({
        //       left: 150,
        //       top: 150,
        //       stroke: this.colorFill, 
        //       fill: '#FFFFFF',
        //       width: 100,
        //       height: 100,
        //       opacity: 1
        //     }));
        //     this.canvasObj.trigger('object:modified');
        // },
        // addEllipse: function(){
        //     this.createEllipse();
        //     this.canvasObj.trigger('object:modified');
        // },
        // createEllipse(options) {
        //     options = Object.assign({
        //       rx: 20, ry: 40, fillColor: 'rgba(255, 255, 255, 0)', angle: 90, strokeColor: '#333', strokeWidth: 2, left: 150, top: 150
        //     }, options);
        //     const ellipse = new fabric.Ellipse({
        //       ...options,
        //       fill: options.fillColor,
        //       stroke: options.strokeColor
        //     });
        //     this.canvasObj.add(ellipse);
        //     this.canvasObj.renderAll();
        // },
        // addArrowLine: function(){
        //     var triangle = new fabric.Triangle({
        //         width: 10, 
        //         height: 15, 
        //         fill: this.colorFill, 
        //         left: 235, 
        //         top: 65,
        //         angle: 90
        //     });
    
        //     var line = new fabric.Line([50, 100, 200, 100], {
        //         left: 75,
        //         top: 70,
        //         stroke: this.colorFill,
        //     });
    
        //     var objs = [line, triangle];
    
        //     var alltogetherObj = new fabric.Group(objs);
        //     this.canvasObj.add(alltogetherObj);
        //     this.canvasObj.trigger('object:modified');
        // },
        // addDottedline: function(){
        //     var dotline = new fabric.Line([0, 20, 150, 20], {
        //         left: 175,
        //         top: 170,
        //         strokeDashArray: [5, 5],
        //         stroke: this.colorFill,
        //         strokeWidth: 2
        //     });
        //     this.canvasObj.add(dotline);
        //     this.canvasObj.trigger('object:modified');
        // },
        // addImageUrl: function(imageUrl){
        //     const canvas = this.canvasObj;
        //     fabric.Image.fromURL(imageUrl, function(image) {
        //         const maxWidth = canvas.width / 2;
        //         const maxHeight = canvas.height / 2;
        //         let width = image.width;
        //         let height = image.height;
        //         if (image.width > maxWidth){
        //             width = maxWidth;
        //         }
        //         if (image.height > maxHeight){
        //             height = maxHeight;
        //         }
        //         image.set({ 'left': 50 });
        //         image.set({ 'top': 50 });
        //         image.scaleToWidth(width);
        //         image.scaleToHeight(height);

        //         canvas.add(image);
        //         canvas.trigger('object:modified');
        //     });
        // },

        // addVideo: function (obj) {
        //     const canvas = this.canvasObj;
        //     const canvasHeight = this.canvasHeight;
        //     const playVideo = this.playVideo;
        //     const videoUrl = this.baseUrl + '/' + obj.fileRef;
        //     fabric.Image.fromURL(this.posterVideo, function(image) {
        //         const maxWidth = canvas.width / 2;
        //         const maxHeight = canvas.height / 2;
        //         let width = image.width;
        //         let height = image.height;
        //         if (image.width > maxWidth){
        //             width = maxWidth;
        //         }
        //         if (image.height > maxHeight){
        //             height = maxHeight;
        //         }
        //         image.set({ 'left': 0 });
        //         image.set({ 'top': canvasHeight - 64 });
        //         image.scaleToWidth(width);
        //         image.scaleToHeight(height);
        //         image.set('video_src', videoUrl);
        //         image.set('file_name', obj.name);
        //         image.on('mousedblclick', function(e) {
        //             playVideo(obj);
        //         });
        //         canvas.add(image);
        //         canvas.trigger('object:modified');
        //     });
        // },

        // addAudio: function(obj){
        //     const canvas = this.canvasObj;
        //     const canvasHeight = this.canvasHeight;
        //     const canvasWidth = this.canvasWidth;
        //     const playAudio = this.playAudio;
        //     const audioUrl = this.baseUrl + '/' + obj.fileRef;
        //     fabric.Image.fromURL(this.posterAudio, function(image) {
        //         const maxWidth = canvas.width / 2;
        //         const maxHeight = canvas.height / 2;
        //         let width = image.width;
        //         let height = image.height;
        //         if (image.width > maxWidth){
        //             width = maxWidth;
        //         }
        //         if (image.height > maxHeight){
        //             height = maxHeight;
        //         }
        //         image.set({ 'left': canvasWidth - 64 });
        //         image.set({ 'top': canvasHeight - 64 });
        //         image.scaleToWidth(width);
        //         image.scaleToHeight(height);
        //         image.set('audio_src', audioUrl);
        //         image.set('file_name', obj.name);
        //         image.on('mousedblclick', function(e) {
        //             playAudio(obj);
        //         });
        //         canvas.add(image);
        //         canvas.trigger('object:modified');
        //     });
        // },

        // handleMouseDbClick(obj){
        //     if(obj.video_src != null && obj.video_src != ''){
        //         var videoObj = { FileName: obj.file_name, FullPath: obj.video_src };
        //         this.playVideo(videoObj);
        //     }
        //     else if(obj.audio_src != null && obj.audio_src != ''){
        //         var audioObj = { FileName: obj.file_name, FullPath: obj.audio_src };
        //         this.playAudio(audioObj);
        //     }
        // },

        // showModal(type, obj) {
        //     this.currentObject = obj;
        //     if(type == 1){
        //         // $('#popup-image').modal();
        //     }
        //     else if(type == 2){
        //         this.playVideo(obj);
        //     }
        //     else if(type == 3){
        //         this.playAudio(obj);
        //     }
        // },

        // playAudio(audioObj) {
        //     this.currentObject = audioObj;
        //     var video = document.getElementById('audio');
        //     video.src = this.baseUrl + "/" + audioObj.fileRef;
        //     video.type = 'audio/mp3';
        //     video.play();
        //     // $('#popup-audio').modal();
        // },

        // playVideo(videoObj) {
        //     this.currentObject = videoObj;
        //     var video = document.getElementById('video');
        //     video.src = this.baseUrl + "/" + videoObj.fileRef;
        //     video.play();
        //     // $('#popup-video').modal();
        // },
        
        // addImage: function(e) {
        //     const canvas = this.canvasObj;
        //     var file = e.target.files[0];
        //     var reader = new FileReader();
        //     reader.onload = function(file) {
        //         fabric.Image.fromURL(file.target.result, function(img) {
        //             img.set({ 'left': 50 });
        //             img.set({ 'top': 50 });
        //             img.scaleToWidth(100);
        //             img.scaleToHeight(100);
                            
        //             canvas.add(img);
        //         });
        //     }
        //     reader.readAsDataURL(file);
        //     this.canvasObj.trigger('object:modified');
        // },

        // setCanvasBgImage: function(e) {
        //     const canvas = this.canvasObj;
        //     var file = e.target.files[0];
        //     var reader = new FileReader();
        //     reader.onload = function(file) {
        //         fabric.Image.fromURL(file.target.result, function(img) {
        //             img.set({ 'left': 0 });
        //             img.set({ 'top': 0 });
        //             img.scaleX = canvas.width / img.width;
        //             img.scaleY = canvas.height / img.height;
        //             img.scaleToWidth(canvas.width);
        //             img.scaleToHeight(canvas.height);
                            
        //             canvas.setBackgroundImage(img);
        //             canvas.requestRenderAll();
        //         });
        //     }
        //     reader.readAsDataURL(file);
        // },

        // deleteObject: function() {
        //     var t = this.canvasObj.getActiveObject();
        //     t && this.canvasObj.remove(t)
        // },
        // bringToFront: function() {
        //     var t = this.canvasObj.getActiveObject();
        //     this.canvasObj.bringToFront(t), this.canvasObj.renderAll();
        //     this.canvasObj.trigger('object:modified');
        // },
        // sendToBack: function() {
        //     var t = this.canvasObj.getActiveObject();
        //     this.canvasObj.sendToBack(t), this.canvasObj.renderAll();
        //     this.canvasObj.trigger('object:modified');
        // },
        
        // setText: function() {
        //     this.setActiveProp('text', this.textIText);
        // },

        // getCanvasBgColor() {
        //     return this.canvasObj.backgroundColor;
        // },
        
        // setCanvasBgColor(color) {
        //     this.canvasObj.setBackgroundImage(null);
        //     this.canvasObj.backgroundColor = color;
        //     this.canvasObj.renderAll();
        //     this.canvasObj.trigger('object:modified');
        // },

        // getCanvasBgColor() {
        //     return this.canvasObj.backgroundColor;
        // },

        // getCanvasBgColor() {
        //     return canvas.backgroundColor;
        // },

        // getText() {
        //     return getActiveProp('text');
        // },

        // saveToSVG: function(){
        //     this.canvasSVG = this.canvasObj.toSVG();
        //     document.getElementById('SVGRasterizer').innerHTML = this.canvasSVG;
        // },

        // saveToJson: function(){
        //     this.canvasJson = JSON.stringify(this.canvasObj.toJSON());
        // },

        // // saveToImage: function(){
        // //     this.canvasImage = this.canvasObj.toDataURL({ format: 'png' });
        // //     document.getElementById('canvasRasterizer').src = this.canvasImage;
        // // },

        // loadJson() {
        //     this.canvasObj.loadFromJSON(this.canvasLoadJson);
        // },

        // loadSvg(svg) {
        //     const that = this;
        //     fabric.loadSVGFromString(svg, function(objects, options){
        //         objects.forEach((obj, i) => {
        //             that.canvasObj.add(obj);
        //         });
        //     });
        // },

        // clearCanvas() {
        //     this.canvasObj.clear();
        // },

        // handleCanvasZoom(svg){
           
        // },

        // handleResize() {
            
        // },

        // initCanvasSize(){
            
        // },
        // resizeCanvas(){
        //     // $("#main-canvas").css("margin-left", "350px");
        // },
        
        // closeDsResize(){
            
        // },
    },
	}
</script>

<style lang="scss" scoped>
  .form-action {
    padding: 30px 0 10px;

    >* {
      &:not(:last-child) {
        margin-right: 15px;
      }
    }
  }  
</style>